<template>
<div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-dark">
    </base-header>
    <card>
        <b-container fluid class="mt--6">
            <b-row>
                <b-col>
                    <div class="card-wrapper">
                        <card>
                            <h2 class="mb-0">STATUS GAJI KUP BERMULA 2015</h2>
                            <br />
                            <b-row class="my-1">
                                <b-col sm="3">
                                    <label>NAMA</label>
                                </b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="5">{{NamaPeribadi}}</b-col>
                            </b-row>
                            <b-row class="my-1">
                                <b-col sm="3">
                                    <label>NO KAD PENGENALAN</label>
                                </b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="5" class="col text-left">{{NoKP}}</b-col>
                                <!-- <b-button variant="default">Carian Pengguna</b-button> -->
                            </b-row>
                            <b-row>
                                <b-col sm="7">
                                    <b-form-group label="STATUS GAJI KUP BERMULA 2015" v-slot="{ ariaDescribedby }">
                                        <b-form-radio-group variant="success" id="btn-radios-1" v-model="StatusGajiKUP" :options="options" :aria-describedby="ariaDescribedby" name="radios-stacked" stacked></b-form-radio-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </card>
                    </div>
                </b-col>
            </b-row>
            <br />
            <div v-if="StatusGajiKUP == 1">
                <validation-observer v-slot="{ invalid }">
                    <card header-classes="bg-transparent">
                        <h3 class="mb-0">**Maklumat Hanya Diisi Untuk Pegawai Yang telah Diluluskan Gaji KUP Bermula Tahun 2015</h3>
                        <br />
                        <div class="pl-lg-4">
                            <validation-provider name="Tarikh Dijangka Bersara" :rules="{ required: true }" v-slot="validationContext">
                                <b-row class="my-1">
                                    <b-col sm="3"> Tarikh Kuatkuasa Gaji KUP * </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="3">

                                        <base-input type="date" v-model="ObjKUP.DtGajiKUP" size="sm"></base-input>
                                    </b-col>
                                </b-row>
                            </validation-provider>
                            <b-row>
                                <b-col sm="1"></b-col>
                            </b-row>
                            <validation-provider name="SalGrdPertama" :rules="{ required: true }" v-slot="validationContext">
                                <b-row class="my-1">
                                    <b-col sm="3">Amaun Gaji KUP Yang Diluluskan * </b-col>
                                    <b-col sm="1">:</b-col>
                                    <b-col sm="4">
                                        <b-form-input v-model="ObjKUP.SalKUP" :state="getValidation(validationContext)"></b-form-input>
                                    </b-col>
                                </b-row>
                            </validation-provider>

                            <b-col>&nbsp;</b-col>
                            <b-form-row>
                                <b-col>
                                    <b-form-group>
                                        <div>
                                            <b-col>&nbsp;</b-col>
                                            <b-col align="center">
                                                <b-button variant="success" type="submit" @click="simpan()" v-show="simpa2">SIMPAN</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">KEMBALI</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">SETERUSNYA</b-button>

                                            </b-col>
                                        </div>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>
                        </div>
                    </card>
                </validation-observer>
            </div>
            <div v-if="StatusGajiKUP == 0">
                <card header-classes="bg-transparent">
                    <b-button size="md" variant="primary" @click="next()">SETERUSNYA</b-button>
                    <br />
                </card>
            </div>
        </b-container>
    </card>
</div>
</template>

<script>
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
export default {
    data() {
        return {
            form: {
                NoKP: "830512065661"
            },
            options: [{
                    text: 'YA',
                    value: '1'
                },
                {
                    text: 'TIDAK',
                    value: '0'
                }
            ],
            StatusGajiKUP: null,
            ObjKUP: {},
            active: false,
            simpa2: true,
        }
    },

    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {

            return dirty || validated ? valid : null;
        },

        simpan() {

            this.ObjKUP.StatusGajiKUP=this.StatusGajiKUP;
            this.$store.commit("addMaklGajiKUP", this.ObjKUP);
            this.simpa2 = false;
            this.active = true;
            console.log(this.ObjKUP);

        },

        next() {
            console.log(this.NoKP)
            this.$router.push({
                name: 'STATUS PENETAPAN GAJI PERMULAAN',
            })
        }
    },
    computed: {
        MaklumatPeribadiInStore() {
            return Store.state.MaklumatPeribadi;

            console.log("ini store", Store.state.MaklumatPeribadi);

        },

    },
    created() {

        GetselenggaraService.getSenaraiServClass()
            .then((resp) => {
                this.ServClassList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        this.NamaPeribadi = this.$store.state.MaklumatPeribadi.Nama;
        this.NoKP = this.$store.state.MaklumatPeribadi.NoKP;

    }
}
</script>

<style>
h2 {
    text-decoration: underline;
}

.numbers {
    text-decoration: underline;
    text-decoration-color: white;
}
</style>
